module.exports = __webpack_public_path__ + "team-0526f049d347df9455ca17febf94c1bd.jpg";